// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

export enum OBJECT_VIEW_MODES {
	LIST,
	SMALL_THUMBNAILS,
	THUMBNAILS,
}
